var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          showAdd: _vm.showAdd,
          clearable: _vm.clearable,
          dense: _vm.dense,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.showDescription
              ? {
                  key: "dataItem",
                  fn: function ({ item }) {
                    return [
                      _c("span", { staticClass: "mb-2" }, [
                        _c("strong", [_vm._v(_vm._s(item.name))]),
                        item.description
                          ? _c("small", [
                              _c("br"),
                              _vm._v(" " + _vm._s(item.description)),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }